import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="carousel-loader"
export default class extends Controller {
  static targets = ["carousel", "placeholder", "image"]

  connect() {
    // Detectar si estamos en Hotwire Native
    this.isNative = this.element.dataset.hotwireNative !== undefined || 
                   navigator.userAgent.includes('Hotwire Native')

    // Verificar que existan los targets necesarios
    if (!this.hasImageTarget && !this.hasCarouselTarget) {
      console.warn("carousel-loader controller: missing image and carousel targets")
      if (this.hasPlaceholderTarget) {
        this.placeholderTarget.remove()
      }
      return
    }

    if (this.imageTargets.length === 0) {
      if (this.hasPlaceholderTarget) {
        this.placeholderTarget.remove()
      }
      if (this.hasCarouselTarget) {
        this.carouselTarget.classList.remove("invisible")
      }
      return
    }

    let loadedCount = 0

    const checkAllLoaded = () => {
      if (loadedCount === this.imageTargets.length) {
        if (this.hasPlaceholderTarget) {
          this.placeholderTarget.remove()
        }
        if (this.hasCarouselTarget) {
          this.carouselTarget.classList.remove("invisible")
          this.carouselTarget.classList.add("fade-in")
          
          // Inicializar carousel manualmente si estamos en native
          if (this.isNative) {
            this.initializeNativeCarousel()
          }
        }
      }
    }

    this.imageTargets.forEach((img) => {
      const revealImage = () => {
        img.classList.remove("invisible")
        loadedCount++
        checkAllLoaded()
      }

      if (img.complete) {
        revealImage()
      } else {
        img.addEventListener("load", revealImage)
      }
    })
  }

  initializeNativeCarousel() {
    // Verificar que existe el carousel target
    if (!this.hasCarouselTarget) {
      console.warn("carousel-loader: cannot initialize carousel without carousel target")
      return
    }

    // Verificar si Bootstrap está disponible
    if (typeof window.bootstrap !== 'undefined') {
      try {
        new window.bootstrap.Carousel(this.carouselTarget, {
          interval: 5000,
          ride: 'carousel',
          touch: true // Habilitar gestos táctiles
        })
      } catch (error) {
        console.warn('Error initializing Bootstrap carousel:', error)
        this.fallbackToSimpleCarousel()
      }
    } else {
      this.fallbackToSimpleCarousel()
    }
  }

  fallbackToSimpleCarousel() {
    // Verificar que existe el carousel target
    if (!this.hasCarouselTarget) {
      console.warn("carousel-loader: cannot create fallback carousel without carousel target")
      return
    }

    // Implementación simple de carousel si Bootstrap no está disponible
    const items = this.carouselTarget.querySelectorAll('.carousel-item')
    let currentIndex = 0

    const showSlide = (index) => {
      items.forEach((item, i) => {
        item.classList.toggle('active', i === index)
      })
    }

    // Auto-advance slides
    setInterval(() => {
      currentIndex = (currentIndex + 1) % items.length
      showSlide(currentIndex)
    }, 5000)

    // Touch gestures for native
    if (this.isNative) {
      let startX = 0
      this.carouselTarget.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX
      })

      this.carouselTarget.addEventListener('touchend', (e) => {
        const endX = e.changedTouches[0].clientX
        const diff = startX - endX

        if (Math.abs(diff) > 50) { // Minimum swipe distance
          if (diff > 0) {
            // Swipe left - next
            currentIndex = (currentIndex + 1) % items.length
          } else {
            // Swipe right - previous
            currentIndex = (currentIndex - 1 + items.length) % items.length
          }
          showSlide(currentIndex)
        }
      })
    }
  }
}

